import { Outlet, useLocation } from "react-router-dom";

import ScraperAPILogo from "components/ScraperAPILogo";
import { ReactComponent as ScraperAPIIllustration } from "assets/images/scraperapi-illustration.svg";
import authIllustration from "assets/images/auth-illustration-2026.png";
import { useFeatureSwitch } from "components/FeatureSwitch";
import WebinarPromo, { WEBINAR_START_AT } from "components/WebinarPromo";
import { isPromoPathname } from "components/WebinarPromo/promoVisibility";
import { useWebinarActive } from "components/WebinarPromo/useCountdown";

function DefaultRightPanel() {
  const isRebrand = useFeatureSwitch("REACT_APP_USE_REBRAND_2026");

  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-brandLightest dark:bg-primary-50 rebrand:p-12">
      {isRebrand ? (
        <img src={authIllustration} alt="" className="w-full max-w-[520px] mb-12 border border-dashed border-primary-300 rounded" />
      ) : (
        <ScraperAPIIllustration className="w-3/5 my-16 max-w-[640px]" />
      )}
      <div className="flex flex-col text-2xl lg:text-3xl text-center mb-16 mx-10 rebrand:mb-0 rebrand:mx-0 rebrand:xl:text-4xl rebrand:font-medium rebrand:text-neutral-900">
        <span>Web Scraping is complex.</span>
        <span>We make it simple.</span>
      </div>
    </div>
  );
}

export default function BeforeLoginLayout() {
  const location = useLocation();

  const isPromoRoute = isPromoPathname(location.pathname);
  const isWebinarActive = useWebinarActive(WEBINAR_START_AT);
  const showPromo = isPromoRoute && isWebinarActive;

  return (
    <div className="z-10 flex flex-col md:flex-row w-full min-h-full">
      <div className="flex-1">
        <div className="relative flex items-center justify-center w-full h-full px-4 md:px-8">
          <div className="absolute top-4 left-4 w-44">
            <ScraperAPILogo />
          </div>
          <div className="w-full max-w-[500px] mt-24 mb-20 md:my-20 rebrand:max-w-[400px]">
            <Outlet />
          </div>
        </div>
      </div>
      <div className="relative flex-1">
        {showPromo ? (
          <div className="w-full h-full bg-brandDarkest">
            <WebinarPromo />
          </div>
        ) : (
          <DefaultRightPanel />
        )}
      </div>
    </div>
  );
}
